module.exports = __webpack_public_path__ + "static/media/netresto-5.7aa070dc.png";